const Footnote = (props) => {
  return (
    <span id={`footnote${props.num}`} className="footnote">
      <sup>{props.num}</sup>
    </span>
  )
}

export default Footnote;